// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3F7NB","row":"styles_row__s5OVL"};